import autoTable from "jspdf-autotable";
import { generateAndAddQRCodes } from "./commonTable";
import { layoutConfig, printcertificateConfigData, printCertificateConfiguration } from "./printcertificateConstant";
import { customFontFamily, environmentTableConfig, tableConfiguration } from "./certificateConfig";

export const firstsectionfooter = async () => {
  await generateAndAddQRCodes(layoutConfig.xPositionGlobal, 80, true, true);

  let tables = [];
  let tablerows = [
    {
      content: "Calibration Procedure",
      styles: {
        font: customFontFamily?.boldFont,
        fontStyle: customFontFamily?.bold,
      },
    },
    {
      content: "As Received Conditions",
      styles: {
        font: customFontFamily?.boldFont,
        fontStyle: customFontFamily?.bold,
      },
    },
    {
      content: "As Shipped Condition",
      styles: {
        font: customFontFamily?.boldFont,
        fontStyle: customFontFamily?.bold,
      },
    },
  ];
  tables.push(tablerows);

  tablerows = [
    printcertificateConfigData.certificateDetailsConfig?.calProcRefNo ||
      printcertificateConfigData.certificateDetailsConfig
        ?.calibrationProcedureNo ||
      "",
    printcertificateConfigData.certificateDetailsConfig?.ConOfDuc || "",
    "Cleaned & Calibrated",
  ];
  tables.push(tablerows);

  // Using autoTable to add the table
  autoTable(printCertificateConfiguration.pdfDoc, {
    startY: layoutConfig.yPositionGlobal,
    margin: tableConfiguration?.margins,
    body: tables,
    theme: "grid",
    headStyles: {
      fillColor: false,
      textColor: printCertificateConfiguration.textColor,
      fontSize: printCertificateConfiguration.fontSizes.h2,
      font: customFontFamily?.boldFont,
    },
    styles: {
      fillColor: false,
      textColor: printCertificateConfiguration.textColor,
      lineColor: printCertificateConfiguration.textColor,
      lineWidth: printCertificateConfiguration.lineWidth,
      fontSize: printCertificateConfiguration.fontSizes.h2,
      halign: "left",
      font: customFontFamily?.normalFont,
    },
  });

  layoutConfig.yPositionGlobal +=
    printCertificateConfiguration.pdfDoc.lastAutoTable.finalY + 10;
};

export const extraTbaleENV = async (setPageSection) => {
  await setPageSection();

  let tableRows = [];

  // Calculate the total available width of the table
    const totalPageWidth =
      printCertificateConfiguration.pageWidth -
      tableConfiguration?.margins.right * 2;
    const columnPercentages = [35, 15, 20, 30];
    // Calculate the actual column widths based on percentages
    const columnWidths = columnPercentages.map((percentage) => {
      return (totalPageWidth * percentage) / 100;
    });

  const row = [
     {
      content: "Calibration Reference Standard :",
      styles: {
        halign: "left",
        font: customFontFamily?.boldFont,
        fontStyle: customFontFamily?.bold,
      },
    },
    {
      content: printcertificateConfigData.certificateDetailsConfig?.isaStandard
      ? printcertificateConfigData.certificateDetailsConfig?.isaStandard
      : printcertificateConfigData.certificateDetailsConfig?.referenceStandards,
      styles: {
        halign: "left",
      },
    },
    {
      content: "Calibration Procedure:",
      styles: {
        font: customFontFamily?.boldFont,
        fontStyle: customFontFamily?.bold,
        halign: "left",
      },
    },
    {
      content: printcertificateConfigData.certificateDetailsConfig?.calProcRefNo
          ? printcertificateConfigData.certificateDetailsConfig?.calProcRefNo
          : printcertificateConfigData.certificateDetailsConfig?.calibrationProcedureNo,
      styles: {      
        halign: "left",
      },
    },
  ];
  tableRows.push(row);

  autoTable(printCertificateConfiguration.pdfDoc, {
    startY:
      layoutConfig.yPositionGlobal -
      environmentTableConfig.spacebetweenHeadingandTable,
    margin: tableConfiguration?.margins,
    body: tableRows, // All following rows as table body
    theme: "grid",
    styles: {
      fillColor: false,
      textColor: printCertificateConfiguration.textColor,
      lineColor: printCertificateConfiguration.textColor,
      lineWidth: printCertificateConfiguration.lineWidth,
      fontSize: printCertificateConfiguration.fontSizes.h2,
      halign: "left",
      font: customFontFamily?.normalFont,
      cellPadding: environmentTableConfig.cellPadding,
    },
    tableLineColor: printCertificateConfiguration.textColor,
    tableLineWidth: 0.1,
    bodyStyles: {
      lineWidth: environmentTableConfig.innerBorder,
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
  });

  layoutConfig.yPositionGlobal =
    printCertificateConfiguration.pdfDoc.lastAutoTable.finalY + 10;
};

export const drawAdditionalTable = async (setPageSection) => {
  await setPageSection();
  const tablesdata = [
    [
      {
        content: "Condition of unit under calibration on receipt",
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
        },
      },
      printcertificateConfigData.certificateDetailsConfig?.ConOfDuc || "",
    ],
    [
      {
        content: "Method used - Reva Phoenix Document Number",
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
        },
      },
      printcertificateConfigData.certificateDetailsConfig?.calProcRefNo ||
        printcertificateConfigData.certificateDetailsConfig
          ?.calibrationProcedureNo ||
        "",
    ],
    [
      {
        content: "Reference Standard (International / National)",
        styles: {
          font: customFontFamily?.boldFont,
          fontStyle: customFontFamily?.bold,
        },
      },
      printcertificateConfigData.certificateDetailsConfig?.isaStandard ||
        printcertificateConfigData.certificateDetailsConfig
          ?.referenceStandards ||
        "",
    ],
  ];
  autoTable(printCertificateConfiguration.pdfDoc, {
    startY: layoutConfig.yPositionGlobal,
    margin: tableConfiguration?.margins,
    body: tablesdata,
    theme: "grid",
    styles: {
      fillColor: false,
      textColor: printCertificateConfiguration.textColor,
      lineColor: printCertificateConfiguration.textColor,
      lineWidth: printCertificateConfiguration.lineWidth,
      fontSize: printCertificateConfiguration.fontSizes.h2,
      halign: "left",
      valign: "middle",
      font: customFontFamily?.normalFont,
    },
  });
  layoutConfig.yPositionGlobal =
    printCertificateConfiguration.pdfDoc.lastAutoTable.finalY + 10;
};
